import React from 'react';
import {observer} from 'mobx-react';
import {style as cn, stylesheet} from 'typestyle';
import {color, px} from 'csx';

import {spinner} from '../../styles/style';
import {Store} from '../../stores/store';
import {KPI} from '../../kpi';
import {DIAGRAM_COLORS, getReadableTextColor} from '../../utility/ColorUtils';
import {BlackColor, BlackColorFaded50, Shadow6, WhiteColorFaded20} from '../../styles/colors';

const loadingHoverClassName = cn({
    position: 'absolute',
    background: BlackColorFaded50,
    zIndex: 30,
    lineHeight: px(34),
    textAlign: 'center',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
});

export function LoadingHover() {
    return (
        <div className={loadingHoverClassName}>
            <div className={spinner(20)} />
        </div>
    );
}

export const hoverButtonClassName = cn({
    cursor: 'pointer',
    borderRadius: 2,
    width: 20,
    height: 20,
    textAlign: 'center',
    lineHeight: px(20),
    $nest: {
        '&:hover': {
            backgroundColor: WhiteColorFaded20,
        },
    },
});

interface TermItemProps {
    store: Store;
    title: string;
    forcedTitle?: string;
    channelName: string;
    kpi: KPI;
    secondLine?: string;
    isChannel?: boolean;
}

@observer
export class TermItem extends React.Component<TermItemProps, {}> {
    private removeTermFromDiagram(e) {
        const {title, channelName, kpi, isChannel} = this.props;
        e.preventDefault();
        e.stopPropagation();
        this.props.store.lineDiagramStore.removeTermFromDiagram(title, channelName, kpi, isChannel);
    }

    private selectItemInDiagram(e) {
        const {title, channelName, kpi} = this.props;
        e.preventDefault();
        this.props.store.lineDiagramStore.selectGraph(title, channelName, kpi);
    }

    private showLoadingHoverIfNecessary() {
        const {lineDiagramStore} = this.props.store;
        const {title, channelName, kpi} = this.props;
        if (
            lineDiagramStore.loadedDiagramData.some(
                (loadedDiagram) =>
                    loadedDiagram.searchtermOrProductId === title && loadedDiagram.channel.name === channelName && loadedDiagram.kpi === kpi
            )
        ) {
            return null;
        }
        return <LoadingHover />;
    }

    public render() {
        const {lineDiagramStore} = this.props.store;
        const {title, channelName, kpi} = this.props;

        lineDiagramStore.updateDiagram;

        const colorIndexItem = lineDiagramStore.termColorIndexes.find(
            (colorIndex) => colorIndex.channelName === channelName && colorIndex.kpi === kpi && colorIndex.searchtermOrProductId === title
        );

        const colorHelper =
            colorIndexItem && colorIndexItem.colorIndex !== undefined && DIAGRAM_COLORS[colorIndexItem.colorIndex]
                ? DIAGRAM_COLORS[colorIndexItem.colorIndex]
                : color(BlackColor);

        let opacity = 1;
        if (lineDiagramStore.selectedGraphInDiagram.length !== 0) {
            if (
                !lineDiagramStore.selectedGraphInDiagram.some(
                    (selectedGraph) =>
                        selectedGraph.channelName === channelName && selectedGraph.kpi === kpi && selectedGraph.searchtermOrProductId === title
                )
            ) {
                opacity = 0.2;
            }
        }

        const style = {
            background: colorHelper.toString(),
            color: getReadableTextColor(colorHelper).toString(),
            opacity,
        };

        const kpiName = this.props.store.selectorTableStore.tableColumns()[this.props.kpi].label;

        return (
            <div className={itemCss.container} onClick={this.selectItemInDiagram.bind(this)} style={style}>
                <div className={itemCss.leftContainerBody}>
                    <div className={itemCss.title}>{this.props.forcedTitle ? this.props.forcedTitle : this.props.title}</div>
                    <div className={itemCss.topLine}>{kpiName}</div>
                    <div className={itemCss.bottomLine}>{this.props.secondLine}</div>
                </div>
                <div className={itemCss.rightContainerBody}>
                    <div className={hoverButtonClassName} onClick={this.removeTermFromDiagram.bind(this)}>
                        <i className="fa fa-times" aria-hidden="true" />
                    </div>
                </div>
                {this.showLoadingHoverIfNecessary()}
            </div>
        );
    }
}

const itemCss = stylesheet({
    rightContainerBody: {
        display: 'flex',
        height: '100%',
    },
    leftContainerBody: {
        height: '100%',
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        justifyContent: 'center',
    },
    container: {
        position: 'relative',
        height: 50,
        minWidth: 100,
        display: 'flex',
        marginRight: 5,
        paddingLeft: 5,
        verticalAlign: 'top',
        overflow: 'hidden',
        borderRadius: '2px',
        boxShadow: Shadow6,
    },
    title: {
        fontSize: px(14),
        lineHeight: px(14),
    },
    topLine: {
        whiteSpace: 'nowrap',
        fontSize: px(10),
        lineHeight: px(10),
    },
    bottomLine: {
        whiteSpace: 'nowrap',
        fontSize: px(10),
        lineHeight: px(10),
    },
});



// WEBPACK FOOTER //
// ./src/views/Legend/TermItem.tsx